import { Button } from 'primereact/button';
import { FundDocument } from '~/api/def/endpoints/fundEndpoint';

export const OptionCell = (props: {
  data: FundDocument;
  showEditDocumentDialog: (documentId: string) => void;
}) => {
  return (
    <Button
      label="Edit"
      size="small"
      style={{ height: '28px' }}
      onClick={() => props.showEditDocumentDialog(props.data.id)}
    />
  );
};
